import { useNavigate } from 'react-router-dom'
import { static_img_url } from '../Variables';
import LazyImage from './LazyImage';

function NoData({ message, height = null, button = null, to = '#' }) {
  const navigate = useNavigate()

  return (
    <div className='handlers' style={height ? {overflowY:'hidden', height: height } : {}}>

      <LazyImage src={`${static_img_url}/handlers/notfound.webp`} style={height && { width: '150px' }} />
      <div>{message}</div>
      {button && <button className='primaryButton h7 mt-5' onClick={() => navigate(to)}>{button}</button>}
    </div>
  )
}

export default NoData

// {button ? <button className='h6 secondry-button ps-3 pe-3 m-0' style={{width : 'fit-content'}} onClick={()=>change()}>Create account</button> : <> </>}
